
// This is for lazy loading of the apex charts vendor library;
export default {
  
  install (Vue, options) {
    let isApexLoaded = false
    Vue.prototype.$isApexLoaded = isApexLoaded
    Vue.prototype.$loadApex = (callback) => {
      if (isApexLoaded){
        callback()
      } else {
        const VueApexCharts = () => import(/* webpackChunkName: "vue-apexcharts" */ 'vue-apexcharts');
        Vue.use(VueApexCharts)
        Vue.component('apexchart', VueApexCharts)
        Vue.use()
        isApexLoaded = true;
        callback();
      }
    }
  }
  
}